import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss']
})
export class LanguagesComponent implements OnInit {

  langs = [
    {
      code: 'ab',
      nativeName: 'аҧсуа'
    },
    {
      code: 'aa',
      nativeName: 'Afaraf'
    },
    {
      code: 'af',
      nativeName: 'Afrikaans'
    },
    {
      code: 'ak',
      nativeName: 'Akan'
    },
    {
      code: 'sq',
      nativeName: 'Shqip'
    },
    {
      code: 'am',
      nativeName: 'አማርኛ'
    },
    {
      code: 'ar',
      nativeName: 'العربية'
    },
    {
      code: 'an',
      nativeName: 'Aragonés'
    },
    {
      code: 'hy',
      nativeName: 'Հայերեն'
    },
    {
      code: 'as',
      nativeName: 'অসমীয়া'
    },
    {
      code: 'av',
      nativeName: 'авар мацӀ, магӀарул мацӀ'
    },
    {
      code: 'ae',
      nativeName: 'avesta'
    },
    {
      code: 'ay',
      nativeName: 'aymar aru'
    },
    {
      code: 'az',
      nativeName: 'azərbaycan dili'
    },
    {
      code: 'bm',
      nativeName: 'bamanankan'
    },
    {
      code: 'ba',
      nativeName: 'башҡорт теле'
    },
    {
      code: 'eu',
      nativeName: 'euskara, euskera'
    },
    {
      code: 'be',
      nativeName: 'Беларуская'
    },
    {
      code: 'bn',
      nativeName: 'বাংলা'
    },
    {
      code: 'bh',
      nativeName: 'भोजपुरी'
    },
    {
      code: 'bi',
      nativeName: 'Bislama'
    },
    {
      code: 'bs',
      nativeName: 'bosanski jezik'
    },
    {
      code: 'br',
      nativeName: 'brezhoneg'
    },
    {
      code: 'bg',
      nativeName: 'български език'
    },
    {
      code: 'my',
      nativeName: 'ဗမာစာ'
    },
    {
      code: 'ca',
      nativeName: 'Català'
    },
    {
      code: 'ch',
      nativeName: 'Chamoru'
    },
    {
      code: 'ce',
      nativeName: 'нохчийн мотт'
    },
    {
      code: 'ny',
      nativeName: 'chiCheŵa, chinyanja'
    },
    {
      code: 'zh',
      nativeName: '中文 (Zhōngwén), 汉语, 漢語'
    },
    {
      code: 'cv',
      nativeName: 'чӑваш чӗлхи'
    },
    {
      code: 'kw',
      nativeName: 'Kernewek'
    },
    {
      code: 'co',
      nativeName: 'corsu, lingua corsa'
    },
    {
      code: 'cr',
      nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ'
    },
    {
      code: 'hr',
      nativeName: 'hrvatski'
    },
    {
      code: 'cs',
      nativeName: 'česky, čeština'
    },
    {
      code: 'da',
      nativeName: 'dansk'
    },
    {
      code: 'dv',
      nativeName: 'ދިވެހި'
    },
    {
      code: 'nl',
      nativeName: 'Nederlands, Vlaams'
    },
    {
      code: 'en',
      nativeName: 'English'
    },
    {
      code: 'eo',
      nativeName: 'Esperanto'
    },
    {
      code: 'et',
      nativeName: 'eesti, eesti keel'
    },
    {
      code: 'ee',
      nativeName: 'Eʋegbe'
    },
    {
      code: 'fo',
      nativeName: 'føroyskt'
    },
    {
      code: 'fj',
      nativeName: 'vosa Vakaviti'
    },
    {
      code: 'fi',
      nativeName: 'suomi, suomen kieli'
    },
    {
      code: 'fr',
      nativeName: 'Français'
    },
    {
      code: 'ff',
      nativeName: 'Fulfulde, Pulaar, Pular'
    },
    {
      code: 'gl',
      nativeName: 'Galego'
    },
    {
      code: 'ka',
      nativeName: 'ქართული'
    },
    {
      code: 'de',
      nativeName: 'Deutsch'
    },
    {
      code: 'el',
      nativeName: 'Ελληνικά'
    },
    {
      code: 'gn',
      nativeName: 'Avañeẽ'
    },
    {
      code: 'gu',
      nativeName: 'ગુજરાતી'
    },
    {
      code: 'ht',
      nativeName: 'Kreyòl ayisyen'
    },
    {
      code: 'ha',
      nativeName: 'Hausa, هَوُسَ'
    },
    {
      code: 'he',
      nativeName: 'עברית'
    },
    {
      code: 'hz',
      nativeName: 'Otjiherero'
    },
    {
      code: 'hi',
      nativeName: 'हिन्दी, हिंदी'
    },
    {
      code: 'ho',
      nativeName: 'Hiri Motu'
    },
    {
      code: 'hu',
      nativeName: 'Magyar'
    },
    {
      code: 'ia',
      nativeName: 'Interlingua'
    },
    {
      code: 'id',
      nativeName: 'Bahasa Indonesia'
    },
    {
      code: 'ie',
      nativeName: 'Originally called Occidental; then Interlingue after WWII'
    },
    {
      code: 'ga',
      nativeName: 'Gaeilge'
    },
    {
      code: 'ig',
      nativeName: 'Asụsụ Igbo'
    },
    {
      code: 'ik',
      nativeName: 'Iñupiaq, Iñupiatun'
    },
    {
      code: 'io',
      nativeName: 'Ido'
    },
    {
      code: 'is',
      nativeName: 'Íslenska'
    },
    {
      code: 'it',
      nativeName: 'Italiano'
    },
    {
      code: 'iu',
      nativeName: 'ᐃᓄᒃᑎᑐᑦ'
    },
    {
      code: 'ja',
      nativeName: '日本語 (にほんご／にっぽんご)'
    },
    {
      code: 'jv',
      nativeName: 'basa Jawa'
    },
    {
      code: 'kl',
      nativeName: 'kalaallisut, kalaallit oqaasii'
    },
    {
      code: 'kn',
      nativeName: 'ಕನ್ನಡ'
    },
    {
      code: 'kr',
      nativeName: 'Kanuri'
    },
    {
      code: 'ks',
      nativeName: 'कश्मीरी, كشميري‎'
    },
    {
      code: 'kk',
      nativeName: 'Қазақ тілі'
    },
    {
      code: 'km',
      nativeName: 'ភាសាខ្មែរ'
    },
    {
      code: 'ki',
      nativeName: 'Gĩkũyũ'
    },
    {
      code: 'rw',
      nativeName: 'Ikinyarwanda'
    },
    {
      code: 'ky',
      nativeName: 'кыргыз тили'
    },
    {
      code: 'kv',
      nativeName: 'коми кыв'
    },
    {
      code: 'kg',
      nativeName: 'KiKongo'
    },
    {
      code: 'ko',
      nativeName: '한국어 (韓國語), 조선말 (朝鮮語)'
    },
    {
      code: 'ku',
      nativeName: 'Kurdî, كوردی‎'
    },
    {
      code: 'kj',
      nativeName: 'Kuanyama'
    },
    {
      code: 'la',
      nativeName: 'latine, lingua latina'
    },
    {
      code: 'lb',
      nativeName: 'Lëtzebuergesch'
    },
    {
      code: 'lg',
      nativeName: 'Luganda'
    },
    {
      code: 'li',
      nativeName: 'Limburgs'
    },
    {
      code: 'ln',
      nativeName: 'Lingála'
    },
    {
      code: 'lo',
      nativeName: 'ພາສາລາວ'
    },
    {
      code: 'lt',
      nativeName: 'lietuvių kalba'
    },
    {
      code: 'lu',
      nativeName: ''
    },
    {
      code: 'lv',
      nativeName: 'latviešu valoda'
    },
    {
      code: 'gv',
      nativeName: 'Gaelg, Gailck'
    },
    {
      code: 'mk',
      nativeName: 'македонски јазик'
    },
    {
      code: 'mg',
      nativeName: 'Malagasy fiteny'
    },
    {
      code: 'ms',
      nativeName: 'bahasa Melayu, بهاس ملايو‎'
    },
    {
      code: 'ml',
      nativeName: 'മലയാളം'
    },
    {
      code: 'mt',
      nativeName: 'Malti'
    },
    {
      code: 'mi',
      nativeName: 'te reo Māori'
    },
    {
      code: 'mr',
      nativeName: 'मराठी'
    },
    {
      code: 'mh',
      nativeName: 'Kajin M̧ajeļ'
    },
    {
      code: 'mn',
      nativeName: 'монгол'
    },
    {
      code: 'na',
      nativeName: 'Ekakairũ Naoero'
    },
    {
      code: 'nv',
      nativeName: 'Diné bizaad, Dinékʼehǰí'
    },
    {
      code: 'nb',
      nativeName: 'Norsk bokmål'
    },
    {
      code: 'nd',
      nativeName: 'isiNdebele'
    },
    {
      code: 'ne',
      nativeName: 'नेपाली'
    },
    {
      code: 'ng',
      nativeName: 'Owambo'
    },
    {
      code: 'nn',
      nativeName: 'Norsk nynorsk'
    },
    {
      code: 'no',
      nativeName: 'Norsk'
    },
    {
      code: 'ii',
      nativeName: 'ꆈꌠ꒿ Nuosuhxop'
    },
    {
      code: 'nr',
      nativeName: 'isiNdebele'
    },
    {
      code: 'oc',
      nativeName: 'Occitan'
    },
    {
      code: 'oj',
      nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ'
    },
    {
      code: 'cu',
      nativeName: 'ѩзыкъ словѣньскъ'
    },
    {
      code: 'om',
      nativeName: 'Afaan Oromoo'
    },
    {
      code: 'or',
      nativeName: 'ଓଡ଼ିଆ'
    },
    {
      code: 'os',
      nativeName: 'ирон æвзаг'
    },
    {
      code: 'pa',
      nativeName: 'ਪੰਜਾਬੀ, پنجابی‎'
    },
    {
      code: 'pi',
      nativeName: 'पाऴि'
    },
    {
      code: 'fa',
      nativeName: 'فارسی'
    },
    {
      code: 'pl',
      nativeName: 'polski'
    },
    {
      code: 'ps',
      nativeName: 'پښتو'
    },
    {
      code: 'pt',
      nativeName: 'Português'
    },
    {
      code: 'qu',
      nativeName: 'Runa Simi, Kichwa'
    },
    {
      code: 'rm',
      nativeName: 'rumantsch grischun'
    },
    {
      code: 'rn',
      nativeName: 'kiRundi'
    },
    {
      code: 'ro',
      nativeName: 'română'
    },
    {
      code: 'ru',
      nativeName: 'Pусский'
    },
    {
      code: 'sa',
      nativeName: 'संस्कृतम्'
    },
    {
      code: 'sc',
      nativeName: 'sardu'
    },
    {
      code: 'sd',
      nativeName: 'सिन्धी, سنڌي، سندھی‎'
    },
    {
      code: 'se',
      nativeName: 'Davvisámegiella'
    },
    {
      code: 'sm',
      nativeName: 'gagana faa Samoa'
    },
    {
      code: 'sg',
      nativeName: 'yângâ tî sängö'
    },
    {
      code: 'sr',
      nativeName: 'српски језик'
    },
    {
      code: 'gd',
      nativeName: 'Gàidhlig'
    },
    {
      code: 'sn',
      nativeName: 'chiShona'
    },
    {
      code: 'si',
      nativeName: 'සිංහල'
    },
    {
      code: 'sk',
      nativeName: 'slovenčina'
    },
    {
      code: 'sl',
      nativeName: 'slovenščina'
    },
    {
      code: 'so',
      nativeName: 'Soomaaliga, af Soomaali'
    },
    {
      code: 'st',
      nativeName: 'Sesotho'
    },
    {
      code: 'es',
      nativeName: 'Español'
    },
    {
      code: 'su',
      nativeName: 'Basa Sunda'
    },
    {
      code: 'sw',
      nativeName: 'Kiswahili'
    },
    {
      code: 'ss',
      nativeName: 'SiSwati'
    },
    {
      code: 'sv',
      nativeName: 'svenska'
    },
    {
      code: 'ta',
      nativeName: 'தமிழ்'
    },
    {
      code: 'te',
      nativeName: 'తెలుగు'
    },
    {
      code: 'tg',
      nativeName: 'тоҷикӣ, toğikī, تاجیکی‎'
    },
    {
      code: 'th',
      nativeName: 'ไทย'
    },
    {
      code: 'ti',
      nativeName: 'ትግርኛ'
    },
    {
      code: 'bo',
      nativeName: 'བོད་ཡིག'
    },
    {
      code: 'tk',
      nativeName: 'Türkmen, Түркмен'
    },
    {
      code: 'tl',
      nativeName: 'Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔'
    },
    {
      code: 'tn',
      nativeName: 'Setswana'
    },
    {
      code: 'to',
      nativeName: 'faka Tonga'
    },
    {
      code: 'tr',
      nativeName: 'Türkçe'
    },
    {
      code: 'ts',
      nativeName: 'Xitsonga'
    },
    {
      code: 'tt',
      nativeName: 'татарча, tatarça, تاتارچا‎'
    },
    {
      code: 'tw',
      nativeName: 'Twi'
    },
    {
      code: 'ty',
      nativeName: 'Reo Tahiti'
    },
    {
      code: 'ug',
      nativeName: 'Uyƣurqə, ئۇيغۇرچە‎'
    },
    {
      code: 'uk',
      nativeName: 'українська'
    },
    {
      code: 'ur',
      nativeName: 'اردو'
    },
    {
      code: 'uz',
      nativeName: 'zbek, Ўзбек, أۇزبېك‎'
    },
    {
      code: 've',
      nativeName: 'Tshivenḓa'
    },
    {
      code: 'vi',
      nativeName: 'Tiếng Việt'
    },
    {
      code: 'vo',
      nativeName: 'Volapük'
    },
    {
      code: 'wa',
      nativeName: 'Walon'
    },
    {
      code: 'cy',
      nativeName: 'Cymraeg'
    },
    {
      code: 'wo',
      nativeName: 'Wollof'
    },
    {
      code: 'fy',
      nativeName: 'Frysk'
    },
    {
      code: 'xh',
      nativeName: 'isiXhosa'
    },
    {
      code: 'yi',
      nativeName: 'ייִדיש'
    },
    {
      code: 'yo',
      nativeName: 'Yorùbá'
    },
    {
      code: 'za',
      nativeName: 'Saɯ cueŋƅ, Saw cuengh'
    }
  ];

  userLang = localStorage.getItem('userLang') || navigator.language.substring(0, 2).toLowerCase() || 'en';

  constructor(
    public dataServ: DataService,
    private authServ: AuthService
  ) { }

  ngOnInit() {
  }

  async changeLang() {
    localStorage.setItem('userLang', this.userLang);
    if (this.authServ.profile) {
      this.authServ.profile.locale = this.userLang;
      await this.authServ.putMe(this.authServ.profile);
    }
    window.location.reload();
  }
}
